// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Order_item_requests_VerificarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for POST /so/order_item_requests/verificar/{id}
 *
 * Action endpoint — flips so_oir_verified to 1 and stamps verified_at /
 * verified_by. Emits an empty success envelope (no dados payload).
 *
 * @see So_order_item_requests_model::verify()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Order_item_requests_VerificarResponseDados = null;

export type Order_item_requests_VerificarResponse = ApiResponse<Order_item_requests_VerificarResponseDados>;

registerResponseContract('Order_item_requests_VerificarResponse', {})
